import React from "react";
import * as PropTypes from "prop-types";
import styles from "./TaMhtEditorWidgetQa.module.css";
import MHTApi from "services/MHTApi";
import {TaButton} from "components/taUi/taButton/taButton";
import {TaCard} from "components/taUi/taCard/taCard";
import TaLoaderBar from "components/taUi/taLoaderBar";
import {Checkbox} from 'react-bootstrap';
import {TaIcon} from "components/taUi/taIcon";

const defaultState = {
    processingTaskId: '',
    timeLoaded: 0,
    items: [],
    itemIndex: 0,
    totalCount: 0,
    currentItem: null
};

export class TaMhtEditorWidgetQa extends React.Component {

    static propTypes = {
        mhtId: PropTypes.string.isRequired,
        userRole: PropTypes.string.isRequired,
        getSegmentNumber: PropTypes.func.isRequired,
        scrollToSegmentRequest: PropTypes.func.isRequired,
        checkSaveWarningModal: PropTypes.func.isRequired,
    };


    constructor(props) {
        super(props);
        this.highlight = null;
        this.state = {
            ...defaultState,
            formData: {
                ng: !this.isFEor2ndFe(),
                term: !this.isFEor2ndFe(),
                hunspell: !this.isFEor2ndFe(),
                lt_spell: this.isFEor2ndFe(),
                lt_grammar: this.isFEor2ndFe(),
            }
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.processingTaskId !== this.state.processingTaskId
            && this.state.processingTaskId
        ) {

            if (this.state.items.length) {
                const segment_id = this.state.items[this.state.itemIndex].segment_id;
                this.props.scrollToSegmentRequest(segment_id);
            }
        }
        if (
            prevState.timeLoaded !== this.state.timeLoaded ||
            prevState.itemIndex !== this.state.itemIndex
        ) {

            if (this.state.items.length) {
                const segment_id = this.state.items[this.state.itemIndex].segment_id;
                this.props.scrollToSegmentRequest(segment_id);
            }
        }
    }

    onPrevItem = () => {
        const currentItemIndex = parseInt(this.state.itemIndex) || 0;
        const index = (currentItemIndex ? currentItemIndex : this.state.items.length) - 1;
        this.setState({ itemIndex: index });
    }
    
    onNextItem = () => {
        const currentItemIndex = parseInt(this.state.itemIndex) || 0;
        let index = (currentItemIndex + 1) === this.state.items.length ? 0 : currentItemIndex + 1;
        this.setState({ itemIndex: index });
    }

    requestQaCheck = () => {
        this.props.checkSaveWarningModal(this.runQaCheck);
    }

    runQaCheck = () => {
        this.setState({
            ...defaultState,
        });
        MHTApi.getQaCheckTaskId(this.props.mhtId, this.state.formData).then(response => {
            if (response.data && response.data.task_id) {
                this.setState({
                    processingTaskId: response.data.task_id,
                });
            }
        });
    }

    onHandleQaCheckResponse = (items) => {
        this.setState({
            ...defaultState,
            timeLoaded: Date.now(),
            items: items.map(item => ({
                ...item,
                done: false
            })),
            itemIndex: 0,
        });
    }

    handleCheckBox = (e, field) => {
        this.setState({
            formData: {
                ...this.state.formData,
                [field]: e.target.checked
            }
        })
    }

    isFEor2ndFe = () => {
        return this.props.userRole == "finalEditor" || this.props.userRole == "secondFinalEditor"
    }

    isAllFalse = () => {
        return !Object.values(this.state.formData).some(value => value === true);
    }

    renderSelection = () => {
        if (this.isFEor2ndFe()) return null;

        // if (this.isFEor2ndFe()) return (
        //     <div style={{
        //         display: 'flex',
        //         alignItems: 'center',
        //         gap: '16px',
        //         margin: '5px 0'
        //       }}>
        //         <Checkbox
        //           name="lt_spell"
        //           style={{ marginTop: '-5px' }}
        //           value={this.state.formData.lt_spell}
        //           checked={this.state.formData.lt_spell}
        //           onChange={e => this.handleCheckBox(e, 'lt_spell')}
        //         >
        //           Spell
        //         </Checkbox>
        //         <Checkbox
        //             name="lt_grammar"
        //             value={this.state.formData.lt_grammar}
        //             checked={this.state.formData.lt_grammar}
        //             onChange={e => this.handleCheckBox(e, 'lt_grammar')}
        //             >
        //             Grammar
        //         </Checkbox>
        //       </div>
        // );
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                margin: '5px 0'
              }}>
                <Checkbox
                  name="ng"
                  style={{ marginTop: '-5px' }}
                  value={this.state.formData.ng}
                  checked={this.state.formData.ng}
                  onChange={e => this.handleCheckBox(e, 'ng')}
                >
                  NG
                </Checkbox>
                <Checkbox
                  name="term"
                  value={this.state.formData.term}
                  checked={this.state.formData.term}
                  onChange={e => this.handleCheckBox(e, 'term')}
                >
                  Term
                </Checkbox>
                <Checkbox
                    name="hunspell"
                    value={this.state.formData.hunspell}
                    checked={this.state.formData.hunspell}
                    onChange={e => this.handleCheckBox(e, 'hunspell')}
                    >
                    Spell
                </Checkbox>
            </div>
        )
    }

    render() {

        const {
            mhtId
        } = this.props;

        const {
            processingTaskId,
            timeLoaded,
            items,
            itemIndex,
        } = this.state;

        return (
            <div className={styles.widget}>
                {this.renderSelection()}
                {!items.length ? (
                    <header className={styles.loading}>
                        {
                            processingTaskId ? (
                                <TaMhtEditorWidgetQaLoader
                                    mhtId={mhtId}
                                    taskId={processingTaskId}
                                    onLoaded={(data) => this.onHandleQaCheckResponse(data)}
                                    onError={(error) => console.error('mht-qa - onError', error)}
                                />
                            ) : (
                                <>
                                    <TaButton
                                        type={'primary'}
                                        icon={'search_check_2'}
                                        label={"Run QA Check"}
                                        disabled={this.isAllFalse()}
                                        onClick={() => this.requestQaCheck()}
                                    />
                                    {timeLoaded?<TaMhtEditorWidgetQaOkay/>:null}
                                </>
                            )
                        }
                    </header>
                ) : items[itemIndex] ? <TaMhtEditorWidgetQaSegment
                    key={itemIndex + timeLoaded}
                    itemCount={items.length}
                    itemIndex={itemIndex}
                    item={items[itemIndex]}
                    goPrevItem={() => this.onPrevItem()}
                    goNextItem={() => this.onNextItem()}
                    disabled={this.isAllFalse()}
                    reloadQaCheck={() => this.requestQaCheck()}
                /> : <p>Item Index {itemIndex} not found</p>
                }
            </div>
        )
    }
}



class TaMhtEditorWidgetQaLoader extends React.Component {

    static propTypes = {
        taskId: PropTypes.string.isRequired,
        mhtId: PropTypes.string.isRequired,
        onLoaded: PropTypes.func.isRequired,
        onError: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.timerID = null;
        this.state = {
            done: false,
            attemptCount: 0
        };

        this.checkTaskProgress = () => {
            if (this.state.attemptCount < 20) {
                this.setState({
                    attemptCount: this.state.attemptCount + 1
                });
                MHTApi.getQaCheckTaskProgress(props.taskId).then(response => {
                    if (response.data.state === "SUCCESS") {
                        this.loadResult();
                    } else {
                        this.recheckTaskProgress();
                    }
                }).catch(error => {
                    this.props.onError({
                        code: 'task_progress',
                        message: 'Error generating QA Check task ID',
                        meta: error
                    });
                });
            } else {
                this.props.onError({
                    code: 'give_up',
                    message: 'Took too long to check QA'
                });
            }
        }
        this.recheckTaskProgress = () => {
            if (this.timerID) {
                clearTimeout(this.timerID);
            }
            this.timerID = setTimeout(() => this.checkTaskProgress(), 100 + (this.state.attemptCount * 300));
        }
        this.loadResult = () => {
            MHTApi.getQaCheckTaskResult(props.mhtId).then(response => {
                // do timout to allow for the progress bar to finish animation
                this.setState({
                    done: true
                });
                if (this.timerID) {
                    clearTimeout(this.timerID);
                }
                this.timerID = setTimeout(() => this.props.onLoaded(response.data), 300);
            }).catch(error => {
                this.props.onError({
                    code: 'task_result',
                    message: 'Error loading QA Check result',
                    meta: error
                });
            });
        }
    }

    componentDidMount() {
        this.checkTaskProgress();
    }

    componentWillUnmount() {
        if (this.timerID) {
            clearTimeout(this.timerID);
        }
    }

    render() {
        return (
            <>
                <TaButton
                    label={"Running QA Check"}
                    disabled={true}
                    isLoading={true}
                />
                <TaLoaderBar percent={this.state.done ? 100 : this.state.attemptCount / 2 * 10}/>
            </>
        )
    }
}

class TaMhtEditorWidgetQaOkay extends React.Component {

    constructor(props) {
        super(props);
        this.timerID = null;
        this.state = {visible: true};
    }

    componentDidMount() {
        this.timerID = setTimeout(() => this.setState({visible: false}), 3000);
    }

    componentWillUnmount() {
        if (this.timerID) {
            clearTimeout(this.timerID);
        }
    }

    render() {
        return this.state.visible ? (
            <div className={styles.okay}>
                <div>QA check completed. No issues found.</div>
                <TaIcon name={'check_circle'}/>
            </div>
        ) : null
    }
}


class TaMhtEditorWidgetQaSegment extends React.Component {

    static propTypes = {
        reloadQaCheck: PropTypes.func.isRequired,
        goPrevItem: PropTypes.func.isRequired,
        goNextItem: PropTypes.func.isRequired,
        itemCount: PropTypes.number.isRequired,
        itemIndex: PropTypes.number.isRequired,
        item: PropTypes.object.isRequired,
        disabled: PropTypes.bool.isRequired,
    };

    constructor(props) {
        super(props);
        this.pollingTimerId = null;
    }

    componentDidMount() {
        // お手製virtualizedによって不可視（実際には代替オブジェクト）になっている
        // セグメントにヒットしたとき、そのIDがgetElementByIdでは見つからない
        // hackyだが、ポーリングして見つかるまで待つ
        const column = this.props.item.column === 'SOURCE' ? 'source' : 'target';
        let parentId = this.props.item.segment_id + '_' + column;
        const stopPolling = pollForElement(
            parentId,
            () => {
                setHighlight(
                    this.props.item.segment_id,
                    this.props.item.token,
                    this.props.item.column === 'SOURCE' ? 'source' : 'target',
                    this.props.item.start_index || 0,
                    this.props.item.end_index || 0,
                );
            },
            30,
            200
        );
        this.pollingTimerId = setTimeout(() => {
            stopPolling();
        }, 5000);

    }

    componentWillUnmount() {
        clearHighlight();
        clearTimeout(this.pollingTimerId);
    }

    render() {
        const {
            item,
            itemIndex,
            itemCount,
            goPrevItem,
            goNextItem,
            disabled,
        } = this.props;

        return item ? (
            <div>

                <header>
                    <div className={styles.header__reset}>
                        <TaButton
                            type={'button'}
                            icon={'refresh'}
                            onClick={() => this.props.reloadQaCheck()}
                            label={'Rerun QA Check'}
                            disabled={disabled}
                        />
                    </div>
                    <div className={styles.header__notes}>
                        <div>{itemIndex + 1} of {itemCount} issues</div>
                    </div>
                    <div className={styles.header__pager}>
                        <TaButton
                            type={'button'}
                            icon={'chevron_left'}
                            className={''}
                            onClick={() => goPrevItem()}
                        />
                        <TaButton
                            type={'button'}
                            icon={'chevron_right'}
                            className={''}
                            onClick={() => goNextItem()}
                        />
                    </div>

                </header>
                <TaCard>
                    <table>
                        <thead>
                        <tr>
                            <th className={styles.col_1}>#</th>
                            <th className={styles.col_2}>Issue</th>
                            {item.message ? <th className={styles.col_3}>Message</th> : null}
                            <th className={styles.col_4}>Word</th>
                            <th className={styles.col_5}>Suggestion</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{item.segment_order}</td>
                            <td>{item.type}</td>
                            {item.message ? <td> {item.message}</td> : null}
                            <td>{item.token}</td>
                            <td className={styles.suggestions}>
                                <ul>
                                    {item.suggestions.map((suggestion, sIndex) => (
                                        <li key={sIndex}>
                                            {suggestion.value}
                                            {suggestion.meta && suggestion.meta.filename ? <aside>
                                                {suggestion.meta.color ? <i style={{background:suggestion.meta.color}}/> : null }
                                                {suggestion.meta.filename}
                                            </aside> : null }
                                        </li>))}
                                </ul>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </TaCard>
            </div>
        ) : null
    }
}

function clearHighlight() {
    // eslint-disable-next-line no-unused-expressions
    CSS.highlights?.delete('qa-highlight');
}

function setHighlight(id, targetText, column='target', startIndex , endIndex ) {

    // console.log('qa-setHighlight for ', id);
    if (!('Highlight' in window)) {
        return;
    }
    if (!id) {
        console.warn('qa-setHighlight missing id');
        return;
    }
    if (!targetText) {
        console.warn('qa-setHighlight missing targetText');
        return;
    }
    clearHighlight();

    let parentId = id;
    if (column === 'source' || column ==='target') {
        parentId += '_'+column;
    }

    const parent = document.getElementById(parentId);
    if (!parent) {
        console.warn(`Parent element with ID '${parentId}' not found.`);
        return;
    }

    const range = new Range();

    const startNodeInfo = findNodeAndOffset(parent, startIndex ||0);
    const endNodeInfo = findNodeAndOffset(parent, endIndex ||0);
    if (!startNodeInfo || !endNodeInfo) {
        console.warn('Could not find the specified text range.');
        return;
    }

    range.setStart(startNodeInfo.node, startNodeInfo.offset);
    range.setEnd(endNodeInfo.node, endNodeInfo.offset);
    // eslint-disable-next-line no-undef
    const highlight = new Highlight(range);
    CSS.highlights.set('qa-highlight', highlight);
}

function findNodeAndOffset(root, targetIndex) {
    // Helper function to find the correct text node and offset

    let currentIndex = 0;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;

    while ((node = walker.nextNode())) {
        const nodeLength = node.nodeValue.length;
        if (currentIndex + nodeLength >= targetIndex) {
            const offset = targetIndex - currentIndex;
            return { node, offset };
        }
        currentIndex += nodeLength;
    }

    return null;
}

function pollForElement(elementId, callback, maxAttempts = 50, intervalMs = 100) {
    let attempts = 0;
    let timerId = null;

    const checkElement = () => {
        const element = document.getElementById(elementId);
        attempts++;

        if (element) {            
            // タイマーを停止
            clearInterval(timerId);
            timerId = null;

            // コールバック関数を実行
            callback(element);
            return;
        }

        if (attempts >= maxAttempts) {            
            // タイマーを停止
            clearInterval(timerId);
            timerId = null;
            return;
        }

        // 継続
    };

    // 初期チェックとインターバル設定
    timerId = setInterval(checkElement, intervalMs);

    // ★ 戻り値としてクリーンアップ（停止）関数を提供する
    return () => {
        if (timerId !== null) {
            clearInterval(timerId);
            timerId = null;
        }
    };
}